import { Pipe, PipeTransform } from '@angular/core';
import { FormUtils } from '@app/utils/form-utils';
import { FormControlToEnumTypeMapping } from '@app/class/income-before-offer.config';

@Pipe({
    name: 'shouldShowInput',
    pure: false,
})
export class ShouldShowInputPipe implements PipeTransform {
    public transform<T>(
        inputName: string,
        config: FormControlToEnumTypeMapping<T>,
        value: T,
        additionalCondition?: (inputName: string, value: T, config: FormControlToEnumTypeMapping<T>) => boolean
    ): boolean {
        return FormUtils.shouldShowInput(config, inputName, value, additionalCondition);
    }
}
